module.exports = __webpack_public_path__ + "5ab3c39970c5a8ba3b5878593ea4ce6b.jpg";